var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["LicenseWebpackPlugin"]: () => __WEBPACK_EXTERNAL_MODULE_license_webpack_plugin_c06c3a4b__.LicenseWebpackPlugin });